import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./styles/designSystem.css";
import "./styles/adminList.css";
import reportWebVitals from "./reportWebVitals";
import Routes from "./Routes/routes";
import { Toaster } from "react-hot-toast";
import { ThemeProvider } from "./providers/ThemeProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  // </React.StrictMode>
  <ThemeProvider defaultTheme="light">
    <Routes />
    <Toaster />
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
